<template>
  <div id="wrap" class="wrap">
    <div class="left-menu-box">
      <main-menu></main-menu>
    </div>
    <div class="right-main-box">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './index.scss';
</style>


<script>
import { mapGetters, mapActions } from "vuex";
import mainMenu from '../main-menu/index'
export default {
  components:{
    mainMenu
  },
  data() {
    return {};
  },
  mounted() {
    
  },
  created(){
    this.$lfy.IsLogin();
  },
  methods: {
    ...mapActions(["setUser", "getBannber"]),
    Banner() {
      this.getBannber().then(res => {
        console.log(res);
      });
    },
    To(path) {
      this.$router.push({ path});
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>
